import { useEffect, useState } from 'react';
import { BreadcrumbManager, BreadcrumbManagerState } from '@coveo/headless';
import Grid from '@mui/material/Grid';
import { Link } from '@lmig/lmds-react-link';
import { IconNotificationClose } from '@lmig/lmds-react-icons';

interface IFacetBreadcrumbsProps {
  breadcrumbManager: React.MutableRefObject<BreadcrumbManager>;
  stateFilter: string;
  onStateFilterChanged: Function;
}
// Currently, this component only displays breadcrumbs from basic facets.
export default function FacetBreadcrumbs({
  breadcrumbManager,
  stateFilter,
  onStateFilterChanged,
}: IFacetBreadcrumbsProps) {
  const [breadcrumbManagerState, setBreadcrumbManagerState] = useState<BreadcrumbManagerState>();
  useEffect(() => {
    const unsub = breadcrumbManager.current.subscribe(() => setBreadcrumbManagerState(breadcrumbManager.current.state));
    return function cleanup() {
      unsub();
    };
  }, [breadcrumbManager]);

  function getDateFacetBreadcrumbs() {
    if (!breadcrumbManagerState) return;
    let dateBreadcrumbs = breadcrumbManagerState.dateFacetBreadcrumbs;
    return dateBreadcrumbs.map((dateBreadcrumb) => (
      <div key={dateBreadcrumb.field} style={{ display: 'inline-block' }}>
        {dateBreadcrumb.values.map((value) => (
          <div key={dateBreadcrumb.field + value.value.start} style={{ display: 'inline-block', marginRight: '10px' }}>
            <Link
              onClick={() => value.deselect()}
              variant="inline"
              style={{ textDecoration: 'none' }}
              className="caption"
            >
              <div className="search-page-facet-breadcrumb">
                <div>
                  <div>
                    <span>
                      {value.value.start.split('@')[0]}-{value.value.end.split('@')[0]}
                    </span>
                  </div>
                  <IconNotificationClose size="16" />
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    ));
  }
  function getCategoryFacetBreadcrumbs() {
    if (!breadcrumbManagerState) return;
    const breadcrumbs = breadcrumbManagerState.categoryFacetBreadcrumbs;
    return breadcrumbs.map((categoryBreadcrumb) => {
      const breadcrumbValue = categoryBreadcrumb.path.map((value) => value.value).join(' / ');
      return (
        <div key={categoryBreadcrumb.field} style={{ display: 'inline-block', marginRight: '10px' }}>
          <Link
            onClick={() => categoryBreadcrumb.deselect()}
            variant="inline"
            style={{ textDecoration: 'none' }}
            className="caption"
          >
            <div key={breadcrumbValue} className="search-page-facet-breadcrumb">
              <div>
                <div>
                  <span>{breadcrumbValue}</span>
                </div>
                <IconNotificationClose size="16" />
              </div>
            </div>
          </Link>
        </div>
      );
    });
  }

  function getFacetBreadcrumbs() {
    if (!breadcrumbManagerState) return;
    const breadcrumbs = breadcrumbManagerState.facetBreadcrumbs;
    return breadcrumbs.map((breadcrumb) => (
      <div key={breadcrumb.field} style={{ display: 'inline-block' }}>
        {breadcrumb.values.map((value) => (
          <div key={breadcrumb.field + value.value.value} style={{ display: 'inline-block', marginRight: '10px' }}>
            <Link
              onClick={() => value.deselect()}
              variant="inline"
              style={{ textDecoration: 'none' }}
              className="caption"
            >
              <div className="search-page-facet-breadcrumb">
                <div>
                  <div>
                    <span>{value.value.value}</span>
                  </div>
                  <IconNotificationClose size="16" />
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    ));
  }

  function getStateFilter(stateFilter: string, onStateFilterChanged: Function) {
    return (
      <div style={{ display: 'inline-block' }}>
        <div style={{ display: 'inline-block', marginRight: '10px' }}>
          <Link
            onClick={() => onStateFilterChanged()}
            variant="inline"
            style={{ textDecoration: 'none' }}
            className="caption"
          >
            <div className="search-page-facet-breadcrumb">
              <div>
                <div>
                  <span>{stateFilter.toUpperCase()}</span>
                </div>
                <IconNotificationClose size="16" />
              </div>
            </div>
          </Link>
        </div>
      </div>
    );
  }

  function getArchivedFilter() {
    return (
      <div style={{ display: 'inline-block' }}>
        <div style={{ display: 'inline-block', marginRight: '10px' }}>
          <Link variant="inline" style={{ textDecoration: 'none' }} className="caption">
            <div className="search-page-facet-breadcrumb">
              <div>
                <div>
                  <span>Archived</span>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    );
  }

  const showArchivedFilter = () => window.location.search.indexOf('archived=true') !== -1;

  return (
    <>
      {breadcrumbManagerState && (
        <Grid container>
          {(showArchivedFilter() || (stateFilter && stateFilter !== '' && stateFilter.toUpperCase() !== 'ALL')) && (
            <Grid size={{ xs: 12 }} style={{ marginBottom: '10px' }}>
              <span className="bold">Filters Applied: &nbsp;</span>
              {stateFilter.toUpperCase() !== 'ALL' && getStateFilter(stateFilter, onStateFilterChanged)}
              {showArchivedFilter() && getArchivedFilter()}
            </Grid>
          )}
          {breadcrumbManagerState.hasBreadcrumbs && (
            <>
              <Grid size={{ xs: 10 }}>
                <span className="bold">Facets Applied: &nbsp;</span>
                {getDateFacetBreadcrumbs()}
                {getFacetBreadcrumbs()}
                {getCategoryFacetBreadcrumbs()}
              </Grid>
              <Grid size={{ xs: 2 }} style={{ textAlign: 'right', alignSelf: 'center' }}>
                <Link
                  style={{ textDecoration: 'none' }}
                  onClick={breadcrumbManager.current.deselectAll}
                  className="caption"
                >
                  Clear All Filters
                </Link>
              </Grid>
            </>
          )}
        </Grid>
      )}
    </>
  );
}
